import t from "@ext/localization/locale/translate";
import { Calendar } from "@ui-kit/Calendar";
import { Icon } from "@ui-kit/Icon";
import { MenuItem } from "@ui-kit/MenuItem";
import { Popover, PopoverContent, PopoverTrigger } from "@ui-kit/Popover";
import { useState } from "react";
import { PropertyValueTags } from "./PropertyValueTags";
import type { PropertyValueProps } from "./types";

export const DatePropertyValue = ({ disabled, isAssigned, onDelete, onSubmit, property }: PropertyValueProps) => {
	const [open, setOpen] = useState(false);
	const rawValue = property.value?.[0];
	const selected = rawValue ? new Date(rawValue) : undefined;

	return (
		<Popover modal={false} onOpenChange={(nextOpen) => !disabled && setOpen(nextOpen)} open={open}>
			<PopoverTrigger asChild>
				<MenuItem
					aria-disabled={disabled}
					aria-label={property.name}
					className="min-h-7 w-full min-w-0 items-center rounded-lg bg-transparent px-1.5 py-0.5 hover:bg-secondary-bg-hover focus-visible:bg-secondary-bg-hover data-[state=open]:bg-secondary-bg-hover"
					onMouseDown={(event) => event.preventDefault()}
					role="button"
					tabIndex={disabled ? -1 : 0}
				>
					{rawValue ? (
						<PropertyValueTags property={property} />
					) : (
						<span className="text-muted-foreground">{t("properties.empty")}</span>
					)}
				</MenuItem>
			</PopoverTrigger>
			<PopoverContent className="w-auto p-0" onCloseAutoFocus={(event) => event.preventDefault()}>
				<Calendar
					className="bg-transparent border-none !shadow-none"
					defaultMonth={selected}
					mode="single"
					onSelect={(value) => {
						if (!value) return;
						onSubmit(property.id, value.toISOString());
						setOpen(false);
					}}
					selected={selected}
				/>
				{isAssigned && (
					<div className="border-t p-1">
						<MenuItem
							className="w-full justify-start gap-2 rounded-lg bg-transparent hover:bg-secondary-bg-hover focus-visible:bg-secondary-bg-hover"
							onClick={() => {
								onDelete(property.id);
								setOpen(false);
							}}
							onKeyDown={(event) => {
								if (event.key !== "Enter" && event.key !== " ") return;
								event.preventDefault();
								onDelete(property.id);
								setOpen(false);
							}}
							role="button"
							tabIndex={0}
						>
							<Icon className="size-4" icon="eraser" />
							{t("clear")}
						</MenuItem>
					</div>
				)}
			</PopoverContent>
		</Popover>
	);
};
